/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classnames from 'classnames';
import './img-input.scss';

const ImgInput = (props) => {
  const {
    inputId,
    inputName,
    inputType,
    inputPattern,
    inputMode,
    inputPlaceholder,
    inputMaxLength,
    inputAutoComplete,
    inputMinLength,
    inputRequired,
    imgLeft,
    imgLeftCallback,
    imgRight,
    imgRightCallback,
    onInputCallback,
    onChangeCallback,
    value,
    hasError,
    role,
    passwordErrorHolderId,
  } = props;

  return (
    <div
      className={classnames(
        'input',
        'd-flex',
        'align-items-center',
        'justify-content-between',
        'input-img',
        { 'input-error': hasError },
      )}
    >
      {imgLeft && (
        <div className="img-left-container" onClick={imgLeftCallback}>
          {imgLeft}
        </div>
      )}
      <input
        className="no-border"
        id={inputId}
        name={inputName}
        type={inputType || 'text'}
        pattern={inputPattern}
        inputMode={inputMode}
        placeholder={inputPlaceholder}
        maxLength={inputMaxLength}
        autoComplete={inputAutoComplete}
        minLength={inputMinLength}
        required={inputRequired}
        onInput={onInputCallback}
        onChange={onChangeCallback}
        data-testid={inputId}
        value={value}
        role={role}
        aria-required={inputRequired}
        aria-describedby={hasError ? (passwordErrorHolderId || 'passwordError') : inputId}
      />
      {imgRight && (
        <div onClick={imgRightCallback} className="img-right-container">
          {imgRight}
        </div>
      )}
    </div>
  );
};

export default ImgInput;
